import React, { useRef } from "react";

// import component
import FormikContainer from "../Formik/FormikContainer";
import FieldContainer from "../Formik/FieldContainer";
import { ErrorMessage, Form } from "formik";
import DButton from "../DButton";
import DCard from "../DCard";
import DImage from "../DImage";
import { Spinner } from "@chakra-ui/react";
import ErrorMsg from "../Formik/Fields/ErrorMsg";

const orderOptions = [
    {
        id: 0,
        title: "اختر...",
        value: "",
    },
    {
        id: 1,
        title: "الاول",
        value: 1,
    },
    {
        id: 2,
        title: "الثاني",
        value: 2,
    },
    {
        id: 3,
        title: "الثالث",
        value: 3,
    },
    {
        id: 4,
        title: "الرابع",
        value: 4,
    },
    {
        id: 5,
        title: "الخامس",
        value: 5,
    },
];
const ProductPrimaryForm = ({
    categoriesOptions = null,
    onSubmit,
    initialValues,
    validationSchema,
    btnText,
}) => {
    const fileRef = useRef();

    const setImageHandler = value => {
        if (value?.type) {
            return URL.createObjectURL(value);
        }
        return value;
    };
    const deleteImageHandler = setFieldValue => {
        fileRef.current.value = "";
        setFieldValue("productImage", "");
    };
    return (
        <DCard className="mt-4">
            <FormikContainer
                onSubmit={onSubmit}
                initialValues={initialValues}
                validationSchema={validationSchema}
            >
                {({ values, setFieldValue, isSubmitting }) => {
                    return (
                        <Form>
                            <div className="md:flex md:flex-col md:items-center">
                                <div className="mb-4 text-center">
                                    <label
                                        className="block mb-2"
                                        htmlFor="productImage"
                                    >
                                        صورة المنتج:
                                    </label>
                                    <FieldContainer
                                        fileRef={fileRef}
                                        name="productImage"
                                        type="file"
                                        accept="image/*"
                                        id="productImage"
                                        hidden
                                    />
                                    {values.productImage && (
                                        <>
                                            <div className="mb-4 relative sm:w-[250px] h-[250px] border border-light-color rounded-sm">
                                                <DImage
                                                    className="w-full h-full object-contain"
                                                    src={setImageHandler(
                                                        values.productImage
                                                    )}
                                                    alt={"product-image"}
                                                    load={true}
                                                />
                                            </div>
                                            <DButton
                                                onClick={() =>
                                                    deleteImageHandler(
                                                        setFieldValue
                                                    )
                                                }
                                                className="text-white"
                                                bgColor="danger"
                                            >
                                                حذف الصورة
                                            </DButton>
                                        </>
                                    )}
                                    <DButton
                                        bgColor="secondry"
                                        onClick={() => fileRef.current?.click()}
                                    >
                                        تحميل صورة
                                    </DButton>
                                    <div className="blokc">
                                        <ErrorMessage
                                            name="productImage"
                                            component={ErrorMsg}
                                        />
                                    </div>
                                </div>
                                <div className="flex gap-2 justify-center">
                                    <div className="mb-4">
                                        <FieldContainer
                                            type="switch"
                                            name="orphan"
                                            id="orphan"
                                            label={
                                                values.orphan
                                                    ? "باقة"
                                                    : "ليست باقة"
                                            }
                                        />
                                    </div>
                                    {initialValues.productName && (
                                        <div className="mb-4">
                                            <FieldContainer
                                                type="switch"
                                                name="is_available"
                                                id="is_available"
                                                label={
                                                    values.is_available
                                                        ? "متاح"
                                                        : "غير متاح"
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                                <div
                                    className={
                                        categoriesOptions
                                            ? "grid sm:grid-cols-3 gap-4"
                                            : ""
                                    }
                                >
                                    <FieldContainer
                                        name="productName"
                                        className="md:w-[300px]"
                                        type="text"
                                        label="الأسم"
                                        id="productName"
                                    />
                                    <FieldContainer
                                        name="order"
                                        className="md:w-[300px]"
                                        type="select"
                                        label="ترتيب المنتج"
                                        id="order"
                                        options={orderOptions}
                                    />
                                    {categoriesOptions && (
                                        <FieldContainer
                                            name="category"
                                            className="md:w-[300px]"
                                            type="select"
                                            label="القسم"
                                            id="category"
                                            options={categoriesOptions}
                                        />
                                    )}
                                </div>
                            </div>
                            <DButton
                                disabled={isSubmitting}
                                type="submit"
                                className="w-full mx-auto rounded-lg flex items-center justify-center md:max-w-[150px] text-white"
                            >
                                {isSubmitting ? <Spinner /> : btnText}
                            </DButton>
                        </Form>
                    );
                }}
            </FormikContainer>
        </DCard>
    );
};

export default ProductPrimaryForm;
